// removed by extract-text-webpack-plugin
module.exports = {"biggest":"_1r7Sqaivp7pFni6_unM7nb","awardBlock":"_16nO-cPI322eD3jhnxxWpB","nominees":"_3vRtN4DwyzF14EvEtfbthF","bitBackground":"_1Bcnp--VteFK6zCkvy2xc8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AwardBlock/BiggestAwardBlock.css
// module id = 170
// module chunks = 0